import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CrmPipeline, CrmStage, KanbanColumn } from '../../types';

interface CrmState {
  pipelines: CrmPipeline[];
  stages: CrmStage[];
  kanbanData: KanbanColumn[];
  loading: boolean;
  error: string | null;
}

const initialState: CrmState = {
  pipelines: [],
  stages: [],
  kanbanData: [],
  loading: false,
  error: null,
};

const crmSlice = createSlice({
  name: 'crm',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setPipelines: (state, action: PayloadAction<CrmPipeline[]>) => {
      state.pipelines = action.payload;
    },
    setStages: (state, action: PayloadAction<CrmStage[]>) => {
      state.stages = action.payload;
    },
    setKanbanData: (state, action: PayloadAction<KanbanColumn[]>) => {
      state.kanbanData = action.payload;
      state.loading = false;
    },
    updateKanbanColumn: (state, action: PayloadAction<KanbanColumn>) => {
      const index = state.kanbanData.findIndex(col => col.id === action.payload.id);
      if (index !== -1) {
        state.kanbanData[index] = action.payload;
      }
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const { 
  setLoading, 
  setPipelines, 
  setStages, 
  setKanbanData, 
  updateKanbanColumn, 
  setError 
} = crmSlice.actions;
export default crmSlice.reducer; 